import { useFGContext, usePrevious } from "nsitools-react";
import * as React from "react";
import { Prompt } from "react-router";

import { useRouter } from "../../hooks";

interface IFGRouteDirtyCheckerProps {
  message?: string;
}

let SKIP_DIRTY_CHECK = false;
export const enableSkipDirtyCheck = () => (SKIP_DIRTY_CHECK = true);
export const clearSkipDirtyCheck = () => (SKIP_DIRTY_CHECK = false);

export const FGRouteDirtyChecker: React.FunctionComponent<
  IFGRouteDirtyCheckerProps
> = ({ message }) => {
  const { formik } = useFGContext();

  const { pathname } = useRouter();
  const previousPathname = usePrevious(pathname);
  React.useEffect(() => {
    if (pathname !== previousPathname) {
      formik.resetForm();
      clearSkipDirtyCheck();
    }
  }, [formik, pathname, previousPathname]);

  return (
    <Prompt
      when={formik.dirty}
      message={() => {
        return SKIP_DIRTY_CHECK ? "__SKIP__" : message;
      }}
    />
  );
};
